<template>
  <div class="mainout">
    <left-menu v-if="showHead"></left-menu>
    <div class="rightw">
      <tags-vies v-if="showHead"></tags-vies>
      <div :class="showHead?'main-content':'main-content nohead'">
        <el-config-provider :locale="locale">
          <router-view ref="nowroute" v-slot="{ Component }">
            <transition>
              <keep-alive :exclude="$store.state.tagsview.exclude">
                <component :is="Component"/>
              </keep-alive>
            </transition>
          </router-view>
        </el-config-provider>
      </div>
    </div>
  </div>
</template>
<script>
import LeftMenu from '@/components/common/LeftMenu.vue'
import TagsVies from '@/components/common/TagsView.vue'
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
export default {
  components: {LeftMenu,TagsVies,ElConfigProvider},
  data(){
    return {
      showHead:false
    }
  },
  setup(){
    return {
      locale: zhCn,
    }
  },
  beforeCreate() {
    localStorage.removeItem('routemap');
  },
  created() {
    if(this.$route.name!='LoginPage') this.checkLogin();
  },
  watch:{
    '$route.path':function(path,old){
      if(old==='/login') this.$store.commit('add_exclude',{name:'Login'});
      this.showHead=path==='/login'?false:true;
      if(this.$route.path!=='/login'){
        var route=Object.assign({},this.$route);
        if (this.$route.query.needquery==='false'){
          route.query={};
          this.$store.commit('add_tagsview',route);
        }else{
          this.$store.commit('add_tagsview',this.$route);
        }
      }
    }
  },
  methods:{
    /**
     * 检测是否登录
     */
    checkLogin:function (){
      var _this=this;
      this.RequestApi('check_login_status.html').then(function (res){
        if (res.status==1){
          if(_this.$route.name!='LoginPage') _this.showHead=true;
        }
      })
    }
  }
}
</script>
<style lang="less">
@import "~@/assets/css/common/app";
.tox.tox-silver-sink.tox-tinymce-aux{
  z-index: 2050!important;
}
.tox-promotion,.tox-statusbar__branding{
  display: none;
}
</style>